import {FC} from "react";
import {motorcycleDetailsConfig} from "./motorcycleDetailsConfig";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {Grid} from "@mui/material";
import {TextInfoItem} from "../../table/TextInfoItem";

interface IMotorcycleDetailsSection {
    details: typeof motorcycleDetailsConfig;
    motorcycle: IMotorcycle;
    isSplit?: boolean;
}

export const MotorcycleDetailsSection: FC<IMotorcycleDetailsSection> = ({
    details,
    motorcycle,
    isSplit,
}) => (
    <Grid container spacing={2}>
        {details.map(({
            param,
            locaId,
        }) => (
            <Grid item xs={12} sm={isSplit ? 6 : 12} key={locaId}>
                <TextInfoItem
                    locaId={locaId}
                    value={motorcycle[param as keyof IMotorcycle] ?? "N/A"}
                />
            </Grid>
        ))}
    </Grid>
);
